"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@loadsure/utils");
const _1 = require(".");
const lodash_1 = require("lodash");
const certificateChangeDetails_1 = __importDefault(require("./certificateChangeDetails"));
class CertificateChange {
    constructor(author, type, date, changes, message) {
        this.author = author;
        this.type = type;
        this.date = date;
        this.changes = changes;
        this.message = message;
    }
    static empty() {
        return new CertificateChange("", _1.eCertificateChangeType.UPDATED, "", []);
    }
    static fromObj(data) {
        if (!data) {
            return CertificateChange.empty();
        }
        const { author, type, date } = data;
        if (!data.changes) {
            throw new Error("data.changes are is not set");
        }
        const changes = data.changes.map(certificateChangeDetails_1.default.fromObj);
        return new CertificateChange(author, type, date, changes, data === null || data === void 0 ? void 0 : data.message);
    }
    static checkExceptionsInChangeHistory(changes) {
        const deliveryDateChange = changes.find(({ fieldMap }) => fieldMap === "shipment.deliveryDate");
        if (deliveryDateChange) {
            const stopDate = changes.find(({ fieldMap, from, to }) => fieldMap !== "shipment.deliveryDate" &&
                from === deliveryDateChange.from &&
                to === deliveryDateChange.to);
            if (stopDate) {
                const index = changes.indexOf(stopDate);
                changes.splice(index, 1);
            }
        }
        const fieldMapsToExclude = [
            "shipment.stops.0.date",
            "shipment.carriers.0.id",
            "assured.id"
        ];
        return changes.filter(({ fieldMap }) => !fieldMapsToExclude.includes(fieldMap));
    }
    static detectCertificateChanges(originalCert, newCert, keyToOmit) {
        const changes = [];
        const omitedKeys = [
            "changeHistory",
            "partner",
            "authorizedUsers",
            "coverage",
            "partnerIds",
            "payment",
            "purchaser",
            "sanctionsChecks",
            ...(keyToOmit || [])
        ];
        try {
            const diffsOriginalWithNew = utils_1.objectCompare(originalCert, newCert, omitedKeys, []);
            const diffsNewWithOriginal = utils_1.objectCompare(newCert, originalCert, omitedKeys, []);
            const diffs = lodash_1.merge(diffsOriginalWithNew, diffsNewWithOriginal);
            Object.keys(diffs).forEach((key) => {
                const certChanges = CertificateChange.getObjectCompareDifferenceFields(originalCert[key], newCert[key], key, diffs[key]);
                if (Array.isArray(certChanges)) {
                    changes.push(...certChanges);
                }
                else if (certChanges instanceof certificateChangeDetails_1.default) {
                    changes.push(certChanges);
                }
            });
            return CertificateChange.checkExceptionsInChangeHistory(changes.filter((change) => change !== undefined));
        }
        catch (error) {
            utils_1.logger.error("error while detecting changes on certificate", error);
            return changes;
        }
    }
    static getObjectCompareDifferenceFields(originalObject, newObject, prefix, diffs) {
        if (diffs !== undefined) {
            if (typeof originalObject === "object") {
                return Object.entries(diffs).flatMap(([key, entry]) => {
                    if (typeof entry === "object" ||
                        (originalObject && typeof originalObject[key] === "object") ||
                        (newObject && typeof newObject[key] === "object")) {
                        return CertificateChange.getObjectCompareDifferenceFields(originalObject !== undefined ? originalObject[key] : undefined, newObject !== undefined ? newObject[key] : undefined, `${prefix}.${key}`, diffs[key]);
                    }
                    if (typeof entry === "string" || typeof entry === "number") {
                        if (Array.isArray(originalObject) && Array.isArray(newObject)) {
                            return certificateChangeDetails_1.default.fromObj({
                                fieldMap: `${prefix}.${key}`,
                                from: newObject.includes(entry) ? "" : entry,
                                to: newObject.includes(entry) ? entry : ""
                            });
                        }
                    }
                    const from = originalObject !== undefined ? originalObject[key] : "";
                    const to = newObject !== undefined ? newObject[key] : "";
                    return certificateChangeDetails_1.default.fromObj({
                        fieldMap: `${prefix}.${key}`,
                        from,
                        to
                    });
                });
            }
            return certificateChangeDetails_1.default.fromObj({
                fieldMap: prefix,
                from: originalObject || "",
                to: newObject || ""
            });
        }
        return undefined;
    }
}
exports.default = CertificateChange;
//# sourceMappingURL=certificateChange.class.js.map